/* wd-flow-band: port of wonderful-flow-landing/pages/band.html inline <script>.
   Stem mixer + theatre film. All DOM lookups are scoped to #wd-flow-band; asset
   paths come from window.WD_FLOW_ASSETS.band (see snippets/wd-flow-asset-urls.liquid)
   instead of relative assets/ paths. */
(function () {
"use strict";
try {

function init() {
var root = document.getElementById("wd-flow-band");
if (!root) return;
var ASSETS = (window.WD_FLOW_ASSETS && window.WD_FLOW_ASSETS.band) || {};

var STEMS = [
  { key:"drums",  url:ASSETS.drumsAudio  },
  { key:"guitar", url:ASSETS.guitarAudio },
  { key:"voice",  url:ASSETS.voiceAudio  }
];
/* picked when it is asked for, not at load, so a rotate or a resize before the
   first watch still gets the right encode */
function filmSrc(){
  return matchMedia("(max-width:760px)").matches
    ? (ASSETS.filmVideoMobile||"") : (ASSETS.filmVideo||"");
}
var VOL  = 0.80;   /* nothing here is ever louder than this */
var RAMP = 0.30;   /* how long a part takes to arrive or leave */

/* Where each line lands in the record, read off the film's own captions. Each
   line holds until the next one starts, so the top of the page is never empty
   through an instrumental stretch. */
var LYRICS = [
  [ 0.00, "Dental offices"          ],
  [ 2.55, "Something is changing"   ],
  [ 6.20, "And it means everything" ],
  [10.85, "This is new"             ],
  [12.65, "This is what to use"     ],
  [17.95, "Something is changing"   ],
  [21.35, "And you can feel it too" ],
  [24.85, "Feels alright"           ],
  [25.85, "This is new"             ]
];

var stage = root.querySelector("#stage");
var lyric = root.querySelector("#lyric");
var hint  = root.querySelector("#hint");
var watch = root.querySelector("#watch");
var close = root.querySelector("#close");
var film  = root.querySelector("#film");
var endbg = root.querySelector("#endbg");
var members = [].slice.call(root.querySelectorAll(".member"));

var VIDEO_MAP = {
  drums:  { src: ASSETS.drumsVideo,  poster: ASSETS.drumsPoster  },
  guitar: { src: ASSETS.guitarVideo, poster: ASSETS.guitarPoster },
  voice:  { src: ASSETS.voiceVideo,  poster: ASSETS.voicePoster  }
};
members.forEach(function(el){
  var key = el.getAttribute("data-part");
  var v = el.querySelector("video");
  var map = VIDEO_MAP[key];
  if(!map || !v) return;
  if(map.src) v.src = map.src;
  if(map.poster) v.poster = map.poster;
});
if(endbg && ASSETS.endloopVideo) endbg.src = ASSETS.endloopVideo;
if(film && ASSETS.filmPoster) film.poster = ASSETS.filmPoster;

var AC = window.AudioContext || window.webkitAudioContext;
var ctx = null, master = null;
var raw = {};      /* key -> undecoded arrayBuffer */
var buf = {};      /* key -> AudioBuffer */
var node = {};     /* key -> {src, gain} */
var on = {}, started = false, watching = false;
var busStart = 0, loopLen = 0, lineNow = -1;

/* ---------------------------------------------------------------- the paper */
/* Animated grain, pure per-pixel noise. Anything periodic reads as streaks on a
   flat color like this one, so the values come from Math.random. */
var gc = root.querySelector("#grain"), gx = gc.getContext("2d");
var TILE = 168, tile = document.createElement("canvas");
tile.width = tile.height = TILE;
var tx = tile.getContext("2d"), img = tx.createImageData(TILE, TILE);

function grain(){
  var d = img.data, i, v;
  for(i = 0; i < d.length; i += 4){
    v = 210 + (Math.random() * 46 | 0);
    d[i] = d[i+1] = d[i+2] = v; d[i+3] = 255;
  }
  tx.putImageData(img, 0, 0);
  gx.clearRect(0, 0, gc.width, gc.height);
  gx.fillStyle = gx.createPattern(tile, "repeat");
  gx.fillRect(0, 0, gc.width, gc.height);
}
function sizeGrain(){
  gc.width = Math.ceil(innerWidth / 2); gc.height = Math.ceil(innerHeight / 2);
  gc.style.width = innerWidth + "px";   gc.style.height = innerHeight + "px";
}
sizeGrain();
addEventListener("resize", sizeGrain);
if(document.documentElement.dataset.sceneMotion === "reduced") grain();   /* OS setting or saved choice, via the layout head */
else { grain(); setInterval(grain, 1000 / 12); }

/* --------------------------------------------------------------- the record */
STEMS.forEach(function(s){
  if(!s.url) return;
  fetch(s.url).then(function(r){ return r.arrayBuffer(); })
              .then(function(b){ raw[s.key] = b; })
              .catch(function(){});
});

/* All three run from the same instant and never stop, so a part switched on
   late is still in time with the ones already going, and the loop stays locked
   across the whole set for as long as the page is open. */
function startBus(done){
  if(started){ done(); return; }
  if(!AC || !raw.drums || !raw.guitar || !raw.voice){ done(); return; }
  started = true;
  ctx = new AC();
  if(ctx.state === "suspended" && ctx.resume) ctx.resume();
  master = ctx.createGain();
  master.gain.value = VOL;
  master.connect(ctx.destination);

  var pending = STEMS.length;
  STEMS.forEach(function(s){
    ctx.decodeAudioData(raw[s.key].slice(0), function(b){
      buf[s.key] = b;
      if(--pending === 0) launch(done);
    }, function(){ if(--pending === 0) launch(done); });
  });
}

function launch(done){
  if(!buf.drums){ done(); return; }
  var t = ctx.currentTime + 0.06;
  STEMS.forEach(function(s){
    if(!buf[s.key]) return;
    var src = ctx.createBufferSource();
    src.buffer = buf[s.key];
    src.loop = true;
    src.loopStart = 0;
    /* mp3 decoding leaves a little encoder padding at the tail; trimming the
       loop point keeps the turnaround from clicking */
    src.loopEnd = buf[s.key].duration - 0.02;
    var g = ctx.createGain();
    /* a part switched on while the stems were still decoding has to come up
       here, or the press is silently swallowed */
    g.gain.value = on[s.key] ? 1 : 0;
    src.connect(g); g.connect(master);
    src.start(t);
    node[s.key] = { src:src, gain:g };
    busStart = t;
    loopLen = src.loopEnd;
  });
  document.documentElement.setAttribute("data-audio", "playing");
  lineNow = -1;
  done();
}

function fade(key, to){
  var n = node[key];
  if(!n) return;
  var now = ctx.currentTime;
  n.gain.gain.cancelScheduledValues(now);
  n.gain.gain.setValueAtTime(n.gain.gain.value, now);
  n.gain.gain.linearRampToValueAtTime(to, now + RAMP);
}

/* ------------------------------------------------------------- the mechanic */
/* A muted loop is allowed to autoplay, but the request is still refused if the
   element is mid-load when it arrives. One retry on the next frame covers it. */
function roll(v, retried){
  if(!v) return;
  var p = v.play();
  if(p && p.catch) p.catch(function(err){
    if(retried){ if(window.console) console.warn("play refused", v.src, err && err.name); return; }
    v.muted = true;
    setTimeout(function(){ roll(v, true); }, 120);
  });
}

function toggle(el){
  var key = el.getAttribute("data-part");
  var v = el.querySelector("video");
  var next = !on[key];
  on[key] = next;
  el.classList.toggle("on", next);
  el.setAttribute("aria-pressed", next ? "true" : "false");
  if(next) roll(v); else { try{ v.pause(); }catch(e){} }
  startBus(function(){ fade(key, next ? 1 : 0); });
  say();
}

function count(){ return (on.drums?1:0) + (on.guitar?1:0) + (on.voice?1:0); }

function say(){
  var n = count();
  if(n === 0) hint.innerHTML = touch ? "Tap one. Tap <b>all three</b>." : "Press one. Press <b>all three</b>.";
  else if(n === 3) hint.innerHTML = "That is the <b>whole band</b>.";
  else hint.innerHTML = "Add <b>another</b>. Or take one away.";
}

/* -------------------------------------------------------------- the theatre */
/* The film has no soundtrack of its own here. Playing all three stems from the
   top IS the full mix, so the record carries the film and there is nothing
   extra to download. */
function openTheatre(){
  if(watching) return;
  watching = true;
  stage.classList.add("watching");
  film.src = filmSrc();

  startBus(function(){
    if(ctx && node.drums){
      /* restart the set from the top so the picture and the record agree */
      var t = ctx.currentTime + 0.08;
      STEMS.forEach(function(s){
        var n = node[s.key];
        if(!n) return;
        n.gain.gain.cancelScheduledValues(ctx.currentTime);
        n.gain.gain.setValueAtTime(n.gain.gain.value, ctx.currentTime);
        n.gain.gain.linearRampToValueAtTime(0, t);
        try{ n.src.stop(t + 0.02); }catch(e){}
      });
      node = {};
      launch(function(){
        STEMS.forEach(function(s){ fade(s.key, 1); });
        filmStart = ctx.currentTime;
        film.currentTime = 0;
        setTimeout(function(){ roll(film); }, 70);
      });
    }else{
      film.muted = false;
      roll(film);
    }
  });
}

var filmStart = 0;
/* Picture and record run off two different clocks; over thirty seconds that
   drifts far enough to pull the words off the beat. */
setInterval(function(){
  if(!watching || !ctx || !film.duration) return;
  var want = ctx.currentTime - filmStart;
  if(want < 0 || want > film.duration) return;
  if(Math.abs(film.currentTime - want) > 0.15) film.currentTime = want;
}, 2000);

function closeTheatre(){
  if(!watching) return;
  watching = false;
  stage.classList.remove("watching");
  try{ film.pause(); }catch(e){}
  film.removeAttribute("src");
  film.load();
  /* hand the mix back to whatever the visitor had switched on */
  if(ctx) STEMS.forEach(function(s){ fade(s.key, on[s.key] ? 1 : 0); });
}

film.addEventListener("ended", closeTheatre);
watch.addEventListener("click", openTheatre);
close.addEventListener("click", closeTheatre);
addEventListener("keydown", function(e){ if(e.key === "Escape") closeTheatre(); });

members.forEach(function(el){
  el.addEventListener("click", function(){ toggle(el); });
});

/* The cone loop behind the sign-up is decoration, so it never blocks anything. */
roll(endbg);

/* Notify form is bound by assets/wd-flow-klaviyo.js. */

/* The words ride the record's clock, not a timer, so they cannot drift apart
   from it however long the page is left open. */
function words(){
  requestAnimationFrame(words);
  if(!ctx || !loopLen) return;
  var at = (ctx.currentTime - busStart) % loopLen;
  if(at < 0) at += loopLen;
  var i = 0;
  for(var k = 0; k < LYRICS.length; k++) if(at >= LYRICS[k][0]) i = k;
  if(i === lineNow) return;
  lineNow = i;
  var el = document.createElement("span");
  el.textContent = LYRICS[i][1];
  lyric.replaceChildren(el);
}
requestAnimationFrame(words);

var touch = !matchMedia("(hover:hover)").matches;
say();
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",init);
}else{
  init();
}

}catch(err){
  if(window.console) console.error("[wd-flow-band] init failed",err);
}
})();
